export const tierConfig = {
    tier: "กำหนด Payment Tier",
    playerTier: "Tier ผู้เล่น",
    tierConfig: "การกำหนดค่า Payment Tier",
    name: "ชื่อ",
    addNewTier: "เพิ่ม Tier Config ใหม่",
    createNewTierConfig: "กำหนดค่า Tier ใหม่",
    minAmount: "จำนวนขั้นต่ำ",
    maxAmount: "จำนวนสูงสุด",
    rewardAmount: "จำนวนรางวัล",
    rewardType: "ประเภทของรางวัล",
    isActive: "มีการใช้งานอยู่",
    activate: "เปิดใช้งาน",
    activated: "เปิดใช้งานแล้ว",
    startDate: "วันที่เริ่มต้น",
    endDate: "วันที่สิ้นสุด",
    duration: "ระยะเวลา",
    activationStatus:'สถานะการเปิดใช้งาน',
    cancel:'ยกเลิก',
    paymentName:'Payment Name',
    action:'Action',
    deleteTierConfig:'ลบ',
    updateTierConfig: "อัพเดท",
    createTierConfig:'สร้าง',
    feeAmount:'ค่าธรรมเนียม',
  };
  